module.exports = require('./helpers/bundle-url').getBundleURL('41kH8') + "logo-dark.ba5147f0.svg";